<template>
  <Card>
    <!-- <template #header>
      Site List
    </template> -->
    <template #content>
  <div class="centre-flex flex-row">
    <h1>Site List</h1>
    &nbsp;
    <Button @click="openSiteInfoDrawer">?</Button>
  </div>
  <Divider />
  <div class="centre-flex flex-col">
    <!-- <Button @click=goToNewSite>New Site</Button> -->
    <table>
      <colgroup>
        <col style="width: 100%" />
        <col style="width: auto" />
        <col style="width: auto" />
      </colgroup>
      <thead>
        <tr>
          <th>Site Name</th>
          <th>Active</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="3" id="new-site-row"><router-link to="/site_edit/new/">Define a new site.</router-link></td>
        </tr>
        <tr v-for="site in sites" :key="site.name">
          <td>
            <router-link :to="'site/' + site.name">{{ site.name }}</router-link>
          </td>
          <td class="shrink-column"><Checkbox v-model="site.visible" binary disabled /></td>
          <td class="shrink-column">
            <Menu :ref="el => { if (el && site.id) menuRefs[site.id] = el }" :model="getMenuItems(site)" :popup="true" />
            <Button 
              icon="pi pi-cog" 
              @click="toggleMenu($event, site)"
              v-tooltip.top="'Configure Site'"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </template>
  </Card>
</template>

<script lang="ts">
import type { Site } from '@/composables/useSites'
import type { PropType } from 'vue'
import { useDrawer } from '@/composables/useDrawer'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { ref } from 'vue'

export default {
  setup() {
    const drawer = useDrawer()
    const router = useRouter()
    const authStore = useAuthStore()
    const menuRefs = ref<Record<number, any>>({})

    const goToNewSite = () => {
      router.push('/site_edit/new/')
    }

    const openSiteInfoDrawer = () => {
      drawer.openDrawer('Site List', [
        'This is a list of all the sites in the database.',
        'Click on a site to view more information.'
      ])
    }

    const deleteSite = async (site: Site) => {
      if (!site.id) {
        console.error('Site has no ID')
        return
      }

      try {
        const csrfToken = await authStore.getCsrfToken()
        const response = await fetch(`/api/sites/${site.id}/`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
          }
        })

        if (!response.ok) {
          throw new Error('Failed to delete site')
        }

        // Refresh the page to update the list
        window.location.reload()
      } catch (error) {
        console.error('Error deleting site:', error)
      }
    }

    const getMenuItems = (site: Site) => {
      return [
        {
          label: 'Delete Site',
          icon: 'pi pi-trash',
          class: 'text-red-500',
          command: () => deleteSite(site)
        }
      ]
    }

    const toggleMenu = (event: Event, site: Site) => {
      if (site.id && menuRefs.value[site.id]) {
        menuRefs.value[site.id].toggle(event)
      }
    }

    return { openSiteInfoDrawer, goToNewSite, deleteSite, getMenuItems, toggleMenu, menuRefs }
  },
  name: 'SiteList',
  props: {
    sites: {
      type: Array as PropType<Site[]>,
      required: true
    }
  }
}
</script>

<style scoped>
.shrink-column {
  text-align: center;
  white-space: nowrap;
}

/* If we remove this the td rules override tailwind */
#new-site-row { 
  text-align: center;
}

:deep(.p-menu) {
  min-width: 150px;
}

:deep(.text-red-500) {
  color: var(--red-500);
}
</style>